export default __webpack_public_path__ + "static/media/css.585ef422.png";